// utils/useScrollRestoration.js or useScrollRestoration.ts if using TypeScript
import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useScrollRestoration = () => {
  const router = useRouter();

  const handleRouteChangeStart = () => {
    const scrollPosition = { x: window.scrollX, y: window.scrollY };
    sessionStorage.setItem(`scrollPosition_${router.pathname}`, JSON.stringify(scrollPosition));
  };

  const handleReloadScroll = () => {
    // Scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const restoreScroll = () => {
    const savedPosition = sessionStorage.getItem(`scrollPosition_${router.pathname}`);
    if (savedPosition) {
      const { x, y } = JSON.parse(savedPosition);
      window.scrollTo({
        top: y,
        left: x,
        behavior: 'smooth', // Add this line for smooth scrolling
      });
    }
  };

  // Add to the same useScrollRestoration hook
  useEffect(() => {
    // Listen for the first load of the page
    window.addEventListener('load', handleReloadScroll);

    // Additionally, ensure scroll to top on Next.js router-based page reloads
    if (router.isReady) handleReloadScroll();

    router.events.on('routeChangeStart', handleRouteChangeStart);

    router.events.on('routeChangeComplete', restoreScroll);

    // Call restoreScroll in case the page is loaded directly.
    if (router.isReady) restoreScroll();

    return () => {
      window.removeEventListener('load', handleReloadScroll);
      router.events.off('routeChangeStart', handleRouteChangeStart);
      router.events.off('routeChangeComplete', restoreScroll);
    };
  }, [router.asPath, router.events, router.isReady]);
};
